/* Code JavaScript - Bundle Recharge (prix dynamique avec propriétés _rc_bundle) */

/* ========= Persistance sélection (localStorage, TTL 30j) ========= */
const MM_BUNDLE_STORAGE_KEY = 'mm_bundle_selection_v1';
const MM_BUNDLE_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function mmBundleSafeStorage() {
  try {
    const t = '__mm_test__';
    window.localStorage.setItem(t, t);
    window.localStorage.removeItem(t);
    return window.localStorage;
  } catch (e) {
    return null;
  }
}

function mmBundleReadSaved() {
  const ls = mmBundleSafeStorage();
  if (!ls) return null;
  try {
    const raw = ls.getItem(MM_BUNDLE_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.savedAt || Date.now() - data.savedAt > MM_BUNDLE_TTL_MS) {
      ls.removeItem(MM_BUNDLE_STORAGE_KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
}

function mmBundleClearSaved() {
  const ls = mmBundleSafeStorage();
  if (!ls) return;
  try { ls.removeItem(MM_BUNDLE_STORAGE_KEY); } catch (e) {}
}

let mmBundleSaveTimer = null;
function mmBundleSaveSelection() {
  const ls = mmBundleSafeStorage();
  if (!ls) return;
  clearTimeout(mmBundleSaveTimer);
  mmBundleSaveTimer = setTimeout(() => {
    try {
      const box = getBundleContainer();
      const minis = [...box.querySelectorAll('.mm-bundle-selected-product')];
      const items = minis.map(mini => ({
        variantId: mini.dataset.variantId,
        quantity: parseInt(mini.querySelector('input[name$="[quantity]"]')?.value || '0', 10) || 0
      })).filter(i => i.variantId && i.quantity > 0);

      if (items.length === 0) {
        ls.removeItem(MM_BUNDLE_STORAGE_KEY);
        return;
      }

      const globalPlan = getGlobalPlanMaster();
      const payload = {
        bundleHandle: getBundleHandle(),
        sellingPlanId: globalPlan ? globalPlan.value : '',
        items,
        savedAt: Date.now()
      };
      ls.setItem(MM_BUNDLE_STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }, 300);
}

function mmBundleShowToast(message) {
  let toast = document.getElementById('mm-bundle-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'mm-bundle-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);background:#1a1a1a;color:#fff;padding:12px 20px;border-radius:8px;font-size:14px;z-index:9999;opacity:0;transition:opacity .25s ease,transform .25s ease;box-shadow:0 4px 12px rgba(0,0,0,.15);max-width:90vw;text-align:center;';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(20px)';
  }, 3500);
}

function mmBundleRestoreSelection() {
  const saved = mmBundleReadSaved();
  if (!saved) return false;
  if (saved.bundleHandle && saved.bundleHandle !== getBundleHandle()) return false;

  let restoredCount = 0;
  (saved.items || []).forEach(item => {
    const card = document.querySelector(`.mm-product-card-bundle[data-variant-id="${item.variantId}"]`);
    if (!card) return;
    const qty = parseInt(item.quantity, 10) || 0;
    if (qty <= 0) return;

    const imageUrl = card.dataset.imageUrl;
    const title = card.dataset.title;
    const priceCents = parseInt(card.dataset.price || '0', 10) || 0;
    const isExcluded = card.dataset.isExcluded === 'true';

    setCardQty(card, qty);
    createSelectedMiniCard({
      variantId: item.variantId,
      quantity: qty,
      imageUrl,
      title,
      priceCents,
      isExcluded
    });
    restoredCount += qty;
  });

  if (saved.sellingPlanId) {
    const globalPlan = getGlobalPlanMaster();
    if (globalPlan && [...globalPlan.options].some(o => o.value === saved.sellingPlanId)) {
      globalPlan.value = saved.sellingPlanId;
    }
  }

  if (restoredCount > 0) {
    mmBundleShowToast('Votre sélection précédente a été restaurée');
    return true;
  }
  return false;
}

/* ========= Bundle core ========= */

/* Container des mini-cards (inputs + visuels de sélection) */
function getBundleContainer() {
  let box = document.getElementById('mmBundleInputs');
  if (!box) {
    box = document.createElement('div');
    box.id = 'mmBundleInputs';
    document.body.appendChild(box);
  }
  return box;
}

/* Input caché parent (items[0]) — variant ID du bundle product */
function getParentVariantId() {
  const el = document.getElementById('mm_bundle_parent_id');
  return el ? String(el.value || '') : '';
}

/* Helpers sélection mini-card */
function findSelectedMiniCard(variantId) {
  const box = getBundleContainer();
  return box.querySelector(`.mm-bundle-selected-product[data-variant-id="${variantId}"]`) || null;
}
function findHiddenPair(mini) {
  if (!mini) return null;
  const idInput = mini.querySelector('input[name$="[id]"]');
  const qtyInput = mini.querySelector('input[name$="[quantity]"]');
  return { idInput, qtyInput };
}

function getCardQty(card) {
  const span = card.querySelector('.mm-bundle-pc-qtty-elem .mm-bundle-pc-qtty');
  if (!span) return 0;
  return parseInt(span.textContent, 10) || 0;
}

function setCardQty(card, qty) {
  refreshProductCardUI(card, qty);
}

function updateSelectionCountUI() {
  const el = document.getElementById('mmQttySelection');
  if (!el) return;
  const count = getSelectionCount();
  el.textContent = String(count);
}


/* ========= Recharge Bundle helpers ========= */

/* Master select global (fréquence) — contient directement les selling_plan_id du bundle product. */
function getGlobalPlanMaster() {
  return (
    document.querySelector('#mm_bundle_plan_master') ||
    document.querySelector('[data-mm-role="bundle-plan"]') ||
    null
  );
}

/* Génère un identifiant aléatoire de 9 caractères (format nanoid pour Recharge). */
function rcNanoId(size) {
  size = size || 9;
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  let id = '';
  const bytes = crypto.getRandomValues(new Uint8Array(size));
  for (let i = 0; i < size; i++) {
    id += chars[bytes[i] % chars.length];
  }
  return id;
}

/* Infos du produit bundle Recharge (exposées via hidden inputs dans le Liquid). */
function getBundleProductId() {
  const el = document.getElementById('mm_bundle_product_id');
  return el ? String(el.value || '') : '';
}
function getBundleHandle() {
  const el = document.getElementById('mm_bundle_handle');
  return el ? String(el.value || '') : '';
}
function getBundleCollectionId() {
  const el = document.getElementById('mm_bundle_collection_id');
  return el ? String(el.value || '') : '';
}


/* ========= Réindexation des inputs ========= */
/* On conserve uniquement id et quantity sur les mini-cards (pour les calculs de totaux).
   parent_id et selling_plan ne sont plus nécessaires car on utilise fetch avec _rc_bundle. */
function reindexBundleInputs() {
  const box = getBundleContainer();
  const minis = [...box.querySelectorAll('.mm-bundle-selected-product')];

  minis.forEach((mini, idx) => {
    const i = idx + 1;

    // id
    let idInput = mini.querySelector('input[name$="[id]"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      mini.appendChild(idInput);
    }
    idInput.name = `items[${i}][id]`;

    // quantity
    let qtyInput = mini.querySelector('input[name$="[quantity]"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      mini.appendChild(qtyInput);
    }
    qtyInput.name = `items[${i}][quantity]`;
  });

  // UI dépendante de la sélection
  updateProgressUI();
  updateTotalsUI();
  updateSelectionCountUI();
  updateExclusionNoticeUI();
  mmBundleSaveSelection();
}

/* ========= UI qty ========= */
function showQtyUI(card) {
  const qtyInput = card.querySelector('.mm-bundle-pc-qtty-elem input[type="number"]');
  const qty = parseInt(qtyInput?.value || '0', 10) || 0;
  refreshProductCardUI(card, qty);
}

function hideQtyUI(card) {
  refreshProductCardUI(card, 0);
}

/* ========= Mini-card ========= */
function createSelectedMiniCard({ variantId, quantity, imageUrl, title, priceCents, isExcluded }) {
  const box = getBundleContainer();

  const wrapper = document.createElement('div');
  wrapper.className = 'mm-bundle-selected-product';
  wrapper.dataset.variantId = String(variantId);
  wrapper.dataset.price = String(priceCents || 0);

  if (isExcluded) wrapper.dataset.isExcluded = 'true';

  // visuel
  if (imageUrl) {
    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = title || '';
    img.width = 300;
    img.height = 300;
    wrapper.appendChild(img);
  }

  const p = document.createElement('p');
  p.textContent = title || '';
  wrapper.appendChild(p);

  // bouton X
  const rmBtn = document.createElement('button');
  rmBtn.type = 'button';
  rmBtn.setAttribute('data-mm-role', 'remove-selected');
  rmBtn.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9940_95036)">
      <path d="M3.52344 3.52539L8.47318 8.47514" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.47656 3.52344L3.52682 8.47318" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs><clipPath id="clip0_9940_95036"><rect width="12" height="12" fill="white"/></clipPath></defs>
  </svg>`;
  rmBtn.addEventListener('click', () => {
    const sourceCard = document.querySelector(`.mm-product-card-bundle[data-variant-id="${variantId}"]`);
    if (sourceCard) {
      setCardQty(sourceCard, 0);
    }
    wrapper.remove();
    reindexBundleInputs();
  });
  wrapper.appendChild(rmBtn);

  // quantité affichée (span "xN")
  const qtySpan = document.createElement('span');
  qtySpan.className = 'mm-bundle-qty';
  qtySpan.textContent = `x${quantity}`;
  wrapper.appendChild(qtySpan);

  // inputs hidden (nommage temporaire, renommés par reindex)
  const idInput = document.createElement('input');
  idInput.type = 'hidden';
  idInput.name = 'items[999][id]';
  idInput.value = String(variantId);
  wrapper.appendChild(idInput);

  const qtyInput = document.createElement('input');
  qtyInput.type = 'hidden';
  qtyInput.name = 'items[999][quantity]';
  qtyInput.value = String(quantity);
  wrapper.appendChild(qtyInput);

  box.appendChild(wrapper);
  reindexBundleInputs();

  return { wrapper, idInput, qtyInput };
}


/* ========= Progress Bars + Totaux ========= */

function getSelectionCount() {
  const box = getBundleContainer();
  const minis = [...box.querySelectorAll('.mm-bundle-selected-product')];
  return minis.reduce((acc, mini) => {
    const qty = parseInt(mini.querySelector('input[name$="[quantity]"]')?.value || '0', 10) || 0;
    return acc + qty;
  }, 0);
}

// Calcule le sous-total de TOUS les produits (pour le prix final et le prix barré)
function getSelectionTotalSubtotalCents() {
  const box = getBundleContainer();
  const minis = [...box.querySelectorAll('.mm-bundle-selected-product')];
  return minis.reduce((sum, mini) => {
    const qty = parseInt(mini.querySelector('input[name$="[quantity]"]')?.value || '0', 10) || 0;
    const price = parseInt(mini.dataset.price || '0', 10) || 0;
    return sum + qty * price;
  }, 0);
}

// Calcule le sous-total des produits ÉLIGIBLES à la réduction
function getSelectionSubtotalCents() {
  const box = getBundleContainer();
  const minis = [...box.querySelectorAll('.mm-bundle-selected-product')];
  return minis.reduce((sum, mini) => {
    const qty = parseInt(mini.querySelector('input[name$="[quantity]"]')?.value || '0', 10) || 0;
    const price = parseInt(mini.dataset.price || '0', 10) || 0;

    const isExcluded = mini.dataset.isExcluded === 'true';
    if (isExcluded) return sum;

    return sum + qty * price;
  }, 0);
}

// Vérifie si au moins un produit exclu est présent
function hasExcludedProducts() {
  const box = getBundleContainer();
  return box.querySelector('.mm-bundle-selected-product[data-is-excluded="true"]') !== null;
}

function getCurrencyCode() {
  return document.querySelector('.mm-bundle-container')?.dataset.currency || 'EUR';
}

function getCurrencySymbol() {
  return document.querySelector('.mm-bundle-container')?.dataset.currencySymbol || '€';
}

function formatEUR(cents) {
  const value = (cents || 0) / 100;
  return value.toLocaleString('fr-FR', { style: 'currency', currency: getCurrencyCode() });
}

/* Lit les paliers depuis le DOM */
function readTiers() {
  const barsContainer = document.querySelector('.mm-bundle-pbs-container');
  if (!barsContainer) return [];
  const nodes = [...barsContainer.querySelectorAll('.mm-bundle-pb-container')];
  return nodes.map((el, idx) => ({
    el,
    inner: el.querySelector('.mm-bundle-pb-inner'),
    discount: parseInt(el.dataset.discountValue || '0', 10) || 0,
    minPriceCents: parseInt(el.dataset.minPriceCents || '0', 10) || 0,
    index: idx
  })).sort((a, b) => a.minPriceCents - b.minPriceCents);
}

// Détermine le % de réduction en fonction du montant éligible
function getCurrentDiscountPercent(eligibleSubtotal) {
  const totalSubtotalCents = eligibleSubtotal;
  const tiers = readTiers();
  if (tiers.length === 0) return 0;
  let disc = 0;
  for (let i = 0; i < tiers.length; i++) {
    if (totalSubtotalCents >= tiers[i].minPriceCents) disc = tiers[i].discount; else break;
  }
  return disc;
}


/**
 * @function updateProgressUI
 * Met à jour l'affichage de la barre de progression et du texte dynamique.
 */
function updateProgressUI() {
  const eligibleSubtotalCents = getSelectionSubtotalCents();
  const tiers = readTiers();
  if (tiers.length === 0) return;

  let currentIdx = -1;
  for (let i = 0; i < tiers.length; i++) {
    if (eligibleSubtotalCents >= tiers[i].minPriceCents) currentIdx = i; else break;
  }
  const nextIdx = currentIdx + 1 < tiers.length ? currentIdx + 1 : -1;

  // LOGIQUE PROPORTIONNELLE POUR LE REMPLISSAGE DES BARRES
  tiers.forEach((t, i) => {
    let pct = 0;

    if (i === tiers.length - 1) {
        pct = (eligibleSubtotalCents >= t.minPriceCents) ? 100 : 0;
    }
    else {
        const visualSegmentEnd = tiers[i + 1].minPriceCents;
        const visualSegmentStart = t.minPriceCents;
        const segmentLength = visualSegmentEnd - visualSegmentStart;

        if (segmentLength > 0 && eligibleSubtotalCents >= visualSegmentStart) {
            const currentProgressInSegment = eligibleSubtotalCents - visualSegmentStart;
            pct = Math.min(100, Math.round((currentProgressInSegment / segmentLength) * 100));
        } else {
            pct = 0;
        }
    }

    if (t.inner) t.inner.style.width = pct + '%';
  });

  // LOGIQUE D'ACTIVATION DU BADGE
  const topLabels = document.querySelectorAll('.mm-bundle-pb-labels-top .mm-bundle-pb-label-top');

  topLabels.forEach(label => {
    label.classList.remove('mm-badge-active');
  });

  if (currentIdx >= 0 && currentIdx < topLabels.length) {
    topLabels[currentIdx].classList.add('mm-badge-active');
  }

  // MISE A JOUR DU TEXTE DYNAMIQUE "Ajoutez X €..."
  const dynamicNb = document.querySelector('.mm-bundle-pb-text-nb');
  const dynamicP = dynamicNb ? dynamicNb.closest('p.mm-title-xxs-regular') : null;
  const finalP = document.querySelector('.mm-bundle-pb-text-final');

  const nbSpan = document.querySelector('.mm-bundle-pb-text-nb');
  const discSpan = document.querySelector('.mm-bundle-pb-text-discount');

  if (nextIdx >= 0) {
    if (nbSpan && discSpan) {
      const remainingCents = Math.max(0, tiers[nextIdx].minPriceCents - eligibleSubtotalCents);
      const remainingEuros = (remainingCents / 100).toFixed(2).replace('.', ',');
      nbSpan.textContent = `${remainingEuros} ${getCurrencySymbol()}`;
      discSpan.textContent = `${tiers[nextIdx].discount}%`;
    }
    if (dynamicP) dynamicP.classList.remove('mm-none');
    if (finalP) finalP.classList.add('mm-none');
  } else {
    if (dynamicP) dynamicP.classList.add('mm-none');
    if (finalP) {
      const lastDisc = tiers[currentIdx]?.discount || 0;
      const spanDiscount = finalP.querySelector('.mm-bundle-pb-text-discount');
      if (spanDiscount) spanDiscount.textContent = lastDisc;
      finalP.classList.remove('mm-none');
    }
  }
}


// Met à jour l'affichage de la notice d'exclusion
function updateExclusionNoticeUI() {
  const noticeEl = document.getElementById('mm-bundle-exclusion-notice');
  if (!noticeEl) return;

  if (hasExcludedProducts()) {
    noticeEl.classList.remove('mm-none');
  } else {
    noticeEl.classList.add('mm-none');
  }
}


function updateTotalsUI() {
  const totalSubtotal = getSelectionTotalSubtotalCents();
  const eligibleSubtotal = getSelectionSubtotalCents();
  const discountPct = getCurrentDiscountPercent(eligibleSubtotal);
  const discountedEligible = Math.round(eligibleSubtotal * (1 - discountPct / 100));
  const excludedSubtotal = totalSubtotal - eligibleSubtotal;
  const finalDiscounted = discountedEligible + excludedSubtotal;

  const totalSpan = document.querySelector('[data-total-price]');
  const compareSpan = document.querySelector('[data-total-compare-at-price]');

  if (totalSpan) totalSpan.textContent = formatEUR(finalDiscounted);

  if (compareSpan) {
    if (discountPct > 0) {
      compareSpan.textContent = formatEUR(totalSubtotal);
    } else {
      compareSpan.textContent = '';
    }
  }
}

/* ========= Handlers + / - ========= */
function mmAddProductToBundle(button) {
  const card = button.closest('.mm-product-card-bundle');
  const variantId = card.dataset.variantId;
  const imageUrl = card.dataset.imageUrl;
  const title = card.dataset.title;
  const priceCents = parseInt(card.dataset.price || '0', 10) || 0;
  const isExcluded = card.dataset.isExcluded === 'true';

  // quantité à ajouter (1, 5, 10, …)
  const toAdd = parseInt(button.dataset.add || '1', 10) || 1;

  // quantité actuelle (depuis le span xN)
  let current = getCardQty(card);
  current += toAdd;
  setCardQty(card, current);

  const existingMini = findSelectedMiniCard(variantId);
  if (existingMini) {
    // maj quantité cachée + span xN de la mini
    const { qtyInput: hiddenQty } = findHiddenPair(existingMini);
    const newQty = (parseInt(hiddenQty.value || '0', 10) || 0) + toAdd;
    hiddenQty.value = String(newQty);

    const qtySpan = existingMini.querySelector('.mm-bundle-qty');
    if (qtySpan) qtySpan.textContent = `x${newQty}`;

    reindexBundleInputs();
  } else {
    createSelectedMiniCard({
      variantId,
      quantity: toAdd,
      imageUrl,
      title,
      priceCents,
      isExcluded
    });
  }
}


function mmRemoveProductFromBundle(button) {
  const card = button.closest('.mm-product-card-bundle');
  const variantId = card.dataset.variantId;

  let current = getCardQty(card);
  if (current <= 0) return;

  current -= 1;
  setCardQty(card, current);

  const mini = findSelectedMiniCard(variantId);
  if (!mini) {
    reindexBundleInputs();
    return;
  }

  if (current === 0) {
    mini.remove();
    reindexBundleInputs();
  } else {
    const { qtyInput: hiddenQty } = findHiddenPair(mini);
    hiddenQty.value = String(current);

    const qtySpan = mini.querySelector('.mm-bundle-qty');
    if (qtySpan) qtySpan.textContent = `x${current}`;

    reindexBundleInputs();
  }
}


function refreshProductCardUI(card, qty) {
  const addBtn = card.querySelector('.mm-bundle-pc-add');
  const qttyElem = card.querySelector('.mm-bundle-pc-qtty-elem');
  const qttySpan = qttyElem ? qttyElem.querySelector('.mm-bundle-pc-qtty') : null;
  const filter = card.querySelector('.mm-bundle-pc-image-filter');
  const filterText = filter ? filter.querySelector('p') : null;

  if (qty > 0) {
    addBtn && addBtn.classList.add('mm-none');
    qttyElem && qttyElem.classList.remove('mm-none');
    if (qttySpan) qttySpan.textContent = String(qty);
    if (filter) {
      filter.classList.remove('mm-none');
      if (filterText) filterText.textContent = `x${qty}`;
    }
  } else {
    addBtn && addBtn.classList.remove('mm-none');
    qttyElem && qttyElem.classList.add('mm-none');
    if (qttySpan) qttySpan.textContent = '0';
    if (filter) {
      filter.classList.add('mm-none');
      if (filterText) filterText.textContent = '';
    }
  }
}


/* ========= Form submission (fetch avec propriétés _rc_bundle) ========= */
function handleBundleFormSubmit(event) {
  event.preventDefault();

  const form = event.target;
  const submitButton = form.querySelector('button[type="submit"]');
  const originalButtonText = submitButton ? submitButton.textContent : '';

  // Vérifier qu'il y a au moins un produit sélectionné
  const selectionCount = getSelectionCount();
  if (selectionCount === 0) {
    alert('Veuillez sélectionner au moins un produit avant d\'ajouter au panier.');
    return;
  }

  // Désactiver le bouton pour éviter les double-clics
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Ajout en cours...';
  }

  // Données du bundle Recharge
  const bundleNanoId = rcNanoId(9);
  const bundleProductId = getBundleProductId();
  const bundleHandle = getBundleHandle();
  const bundleVariantId = getParentVariantId();
  const collectionId = getBundleCollectionId();
  const globalPlan = getGlobalPlanMaster();
  const sellingPlanId = globalPlan ? globalPlan.value : '';
  const rcBundleValue = bundleNanoId + ':' + bundleProductId;

  // Pas de parent dans le panier — Recharge bundles n'ajoutent que les enfants.
  // Chaque enfant porte le selling_plan du bundle product + les propriétés _rc_bundle.
  const items = [];
  const box = getBundleContainer();
  const minis = [...box.querySelectorAll('.mm-bundle-selected-product')];
  minis.forEach(function(mini) {
    const variantId = mini.dataset.variantId;
    const qty = parseInt(mini.querySelector('input[name$="[quantity]"]')?.value || '0', 10) || 0;
    if (qty > 0) {
      items.push({
        id: parseInt(variantId, 10),
        quantity: qty,
        selling_plan: parseInt(sellingPlanId, 10),
        properties: {
          _rc_bundle: rcBundleValue,
          _rc_bundle_parent: bundleHandle,
          _rc_bundle_variant: bundleVariantId,
          _rc_bundle_collection_id: collectionId
        }
      });
    }
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    return res.json();
  })
  .then(function() {
    mmBundleClearSaved();
    window.location.href = '/cart';
  })
  .catch(function(err) {
    console.error('Bundle add to cart error:', err);
    alert('Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  });
}

/* ========= Init ========= */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mm-product-card-bundle').forEach(card => {
    // Bouton "–" dans le bloc quantité
    const qttyMinusBtn = card.querySelector('.mm-bundle-pc-qtty-elem button:first-of-type');
    if (qttyMinusBtn && !qttyMinusBtn.getAttribute('onclick')) {
      qttyMinusBtn.addEventListener('click', () => mmRemoveProductFromBundle(qttyMinusBtn));
    }

    // Etat initial : 0
    refreshProductCardUI(card, 0);
  });

  // Gestionnaire pour le formulaire de bundle
  const bundleForm = document.querySelector('[data-type="bundle-form"]');
  if (bundleForm) {
    bundleForm.addEventListener('submit', handleBundleFormSubmit);
  }

  // Le master select contient directement les selling_plan_id du bundle product
  // Pas besoin de synchro vers les mini-cards
  const globalPlan = getGlobalPlanMaster?.();
  if (globalPlan) {
    globalPlan.addEventListener('change', () => {
      reindexBundleInputs();
    });
  }

  mmBundleRestoreSelection();

  reindexBundleInputs();
  updateProgressUI?.();
  updateTotalsUI?.();
  updateSelectionCountUI();
});


/* ========= Filtres (inchangé) ========= */
(function () {
  function normalizeTag(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  const tagsBox = document.querySelector('.mm-bundle-tags');
  const grid = document.querySelector('.mm-bundle-products');
  const cards = Array.from(document.querySelectorAll('.mm-product-card-bundle'));

  if (tagsBox) {
    let isDragging = false;
    let dragMoved = false;
    let startX = 0;
    let startScrollLeft = 0;

    tagsBox.addEventListener('mousedown', (e) => {
      isDragging = true;
      dragMoved = false;
      startX = e.pageX;
      startScrollLeft = tagsBox.scrollLeft;
      tagsBox.classList.add('mm-bundle-tags--dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const delta = e.pageX - startX;
      if (Math.abs(delta) > 3) dragMoved = true;
      tagsBox.scrollLeft = startScrollLeft - delta;
    });

    function stopDrag() {
      if (!isDragging) return;
      isDragging = false;
      tagsBox.classList.remove('mm-bundle-tags--dragging');
    }
    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('mouseleave', stopDrag);

    // Prevent the drag from triggering a checkbox toggle click
    tagsBox.addEventListener('click', (e) => {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);
  }

  if (!tagsBox || cards.length === 0 || !grid) return;

  const cardTagSets = new WeakMap();
  cards.forEach(card => {
    const raw = card.dataset.tags || '';
    const set = new Set(
      raw.split(',').map(t => t.trim()).filter(Boolean).map(normalizeTag)
    );
    cardTagSets.set(card, set);
  });

  function getSelectedTags() {
    const checked = tagsBox.querySelectorAll('input[type="checkbox"]:checked');
    return Array.from(checked).map(cb => normalizeTag(cb.value));
  }

  let noResultsEl = null;
  function showNoResults() {
    if (!noResultsEl) {
      noResultsEl = document.createElement('div');
      noResultsEl.className = 'mm-no-results';
      noResultsEl.setAttribute('role', 'status');
      noResultsEl.setAttribute('aria-live', 'polite');
      noResultsEl.textContent = 'Aucun résultat pour votre sélection';
      noResultsEl.style.gridColumn = '1 / -1';
      noResultsEl.style.textAlign = 'center';
      noResultsEl.style.padding = '1rem';
    }
    if (!grid.contains(noResultsEl)) grid.appendChild(noResultsEl);
  }
  function hideNoResults() {
    if (noResultsEl && noResultsEl.parentNode) noResultsEl.parentNode.removeChild(noResultsEl);
  }

  function applyFilter() {
    const selected = getSelectedTags();

    if (selected.length === 0) {
      cards.forEach(card => {
        card.style.display = '';
        card.setAttribute('aria-hidden', 'false');
      });
      hideNoResults();
      return;
    }

    let visibleCount = 0;
    cards.forEach(card => {
      const set = cardTagSets.get(card) || new Set();
      const match = selected.some(tag => set.has(tag));
      if (match) {
        card.style.display = '';
        card.setAttribute('aria-hidden', 'false');
        visibleCount++;
      } else {
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
      }
    });

    if (visibleCount === 0) showNoResults();
    else hideNoResults();
  }

  tagsBox.addEventListener('change', applyFilter);
  applyFilter();
})();

// Open/close mobile
function mmBundleToggleMobile(clickedElem) {
  const container = clickedElem.closest('.mm-bundle-product-list-inner');
  container.classList.toggle('mm-openned');
}

// Fermeture au clic en dehors
document.addEventListener('click', (event) => {
  const container = document.querySelector('.mm-bundle-product-list-inner');
  if (!container) return;

  if (container.classList.contains('mm-openned') && !event.composedPath().includes(container)) {
    container.classList.remove('mm-openned');
  }
});

// Fermeture au scroll
window.addEventListener('scroll', () => {
  const container = document.querySelector('.mm-bundle-product-list-inner');
  if (!container) return;

  container.classList.remove('mm-openned');
}, { passive: true });

// Masquage au niveau du footer
(() => {
  const container = document.querySelector('.mm-bundle-product-list-inner');
  const footer = document.querySelector('.mm-footer-container');
  if (!container || !footer) return;

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      container.classList.remove('mm-openned');
      container.style.display = 'none';
    } else {
      container.style.display = '';
    }
  });
  observer.observe(footer);
})();

// Open panel
function mmOpenPanel(clickedElem) {
  const card = clickedElem.closest('.mm-product-card-bundle');
  const panelElem = card.querySelector('.mm-product-card-bundle-preview');
  const section = document.querySelector('.mm-section-bundle');

  panelElem.classList.add('mm-openned');
  section.style.zIndex = "15";
}
function mmClosePanel(clickedElem) {
  const card = clickedElem.closest('.mm-product-card-bundle');
  const panelElem = card.querySelector('.mm-product-card-bundle-preview');
  const section = document.querySelector('.mm-section-bundle');

  panelElem.classList.remove('mm-openned');
  section.style.zIndex = "1";
}
